import { render, staticRenderFns } from "./importAddFee.vue?vue&type=template&id=71a6ae16&scoped=true"
import script from "./importAddFee.vue?vue&type=script&lang=js"
export * from "./importAddFee.vue?vue&type=script&lang=js"
import style0 from "./importAddFee.vue?vue&type=style&index=0&id=71a6ae16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6ae16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a6ae16')) {
      api.createRecord('71a6ae16', component.options)
    } else {
      api.reload('71a6ae16', component.options)
    }
    module.hot.accept("./importAddFee.vue?vue&type=template&id=71a6ae16&scoped=true", function () {
      api.rerender('71a6ae16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/cmp/importAddFee.vue"
export default component.exports